import "@/lib/sentry";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installGlobalErrorHandlers } from "@/lib/globalErrorHandler";

installGlobalErrorHandlers();

createRoot(document.getElementById("root")!).render(<App />);
